export default __webpack_public_path__ + "static/media/outside.309370f6.mp3";